<template>
  <el-form :model="loginModel" :rules="rules" ref="loginForm" label-position="top" :validate-on-rule-change="false">
    <el-form-item :label="$t('message.home.mobilePhone')" prop="username">
      <!-- <div class="form-phone"> -->
        <el-input size="small" v-model.trim="formData.mobile" :placeholder="$t('message.home.pleaseEnterPhoneNumer')" maxlength="30"
          @keyup.enter.native="loginEvent"></el-input>
        <!-- <VueCountryIntl v-model="loginModel.areaCode" schema="popover"
          :searchInputPlaceholder="$t('message.home.searchCountry')" :noDataText="$t('message.home.noDataFound')">
          <div class="area-code flex-between" slot="reference">
            <span>+{{ loginModel.areaCode }}</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
        </VueCountryIntl> -->
      <!-- </div> -->
    </el-form-item>
    <el-form-item prop="code" :label="$t('message.home.verificationCode')">
      <el-row :span="24">
        <el-col :span="16">
          <el-input size="small" v-model="formData.code" @keyup.enter.native="handleLogin" :placeholder="$t('message.home.pleaseEnterVerificationCode')">
            <!-- <i slot="prefix" class="icon-yanzhengma"></i> -->
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <el-button class="sing-in-btn" v-show="getSmsShow"
              style="width: 80%;height: 50px;margin-top: 0px;margin-right: 6px;float: right;" type="primary"
              @click="sendSms()">
              {{$t('message.home.getVerificationCode')}}
            </el-button>
            <el-button class="sing-in-btn" v-show="!getSmsShow"
              style="background-color:#C6C6C6;border-color:#C6C6C6; width: 80%;height: 50px;margin-top: 0px;margin-right: 6px;float: right;"
              type="primary">
              ({{ second }}) {{$t('message.home.tryAgainLater')}}
            </el-button>
          </div>
        </el-col>
      </el-row>

    </el-form-item>



    <!-- <el-form-item :label="$t('message.home.setPassword')" prop="password">
      <el-input
        v-model="loginModel.password"
        :type="showPassword ? 'password' : 'text'"
        :placeholder="$t('message.home.pleaseEnterPassword')"
        @keyup.enter.native="loginEvent"
      >
        <template slot="suffix">
          <img
            class="password-icon"
            :src="showPassword ? imageMap.close : imageMap.open"
            @click="showPassword = !showPassword"
          />
        </template>
</el-input>
</el-form-item> -->
    <div style="display: flex; justify-content: space-between; margin-top: 55px">
      <p class="tips">
        {{ $t("message.home.noAccount") }}
        <span @click="goRegister">{{ $t("message.home.signUp") }}</span>
      </p>
      <!-- <span class="forgot-password" @click="openService">
        {{ $t("message.home.ForgotPassword") }}
      </span> -->
    </div>
    <el-form-item>
      <el-button class="sing-in-btn" type="primary" @click="onSMSLoginUser">
        {{ $t("message.home.signIn") }}
      </el-button>
    </el-form-item>
    <EsOnlineServiceView v-model="showOnlieService" />
    <!-- <Vcode
      :imgs="[img1, img2, img3, img4, img5]"
      :show="showVcoe"
      @success="onVCodeSuccess"
      :canvasHeight="200"
      @close="showVcoe = false"
      :sliderText="$t('message.home.滑动验证')"
      :successText="$t('message.home.vcodePass')"
      :failText="$t('message.home.vcodeFail')"
    /> -->
  </el-form>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import VueCountryIntl from "vue-country-intl";
import common from "@/util/common";
import { BASE_AREA_CODE } from "@/common";
import "vue-country-intl/lib/vue-country-intl.css";
// import Vcode from "vue-puzzle-vcode";
// import { apiGetCustomerService } from "@/api/common";

import {
  loginByPhone,
  loginByThirdParty,
  loginByUsername,
  logout,
  refreshToken
} from '@/api/login.js'
import {
  sendCode
} from "@/api/upms/phone.js"
import { navigateAfterLogin } from "@/util/shopAuth"
import { BIZ_TOKEN } from "@/common/constant"

export default {
  name: "EsMobileForm",
  components: {
    // VueCountryIntl,
    // Vcode
  },
  data() {
    return {
      showOnlieService: false,
      itemname: process.env.VUE_APP_ITEM_NAME,
      loginModel: {
        username: "",
        password: "",
        areaCode: BASE_AREA_CODE,
      },
      showPassword: true,
      showVcoe: false,
      img1: require("@/assets/image/slider/1.png"),
      img2: require("@/assets/image/slider/2.png"),
      img3: require("@/assets/image/slider/3.png"),
      img4: require("@/assets/image/slider/4.png"),
      img5: require("@/assets/image/slider/5.png"),
      imageMap: {
        open: require("@/assets/image/eye-open.png"),
        close: require("@/assets/image/eye-close.png"),
      },
      rules: {
        username: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.pleaseEnterPhoneNumer")
          ),
          common.ruleUtils.getRule("phone"),
        ],
        password: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.pleaseEnterPassword")
          ),
          common.ruleUtils.getRule("password"),
        ],
      },
      onlinePath: "",


      ////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      objsList: [],
      bannerApp: true,
      winWidth: 0,
      winHeight: 0,
      currentTab: 0,
      //tab切换  
      goodsId: 0,
      itemData: {},
      bannerItem: [],
      buynum: 1,
      // 产品图片轮播
      indicatorDots: true,
      autoplay: true,
      interval: 5000,
      duration: 1000,
      // 属性选择
      firstIndex: -1,
      //准备数据
      //数据结构：以一组一组来进行设定
      commodityAttr: [],
      attrValueList: [],
      animationData: "",
      showModalStatus: false,
      includeGroup: "",
      second: 60,
      getSmsShow: true,
      // telephone: "",
      // checkCode: "",
      formData: {
        mobile: '',
        code: ''
      },
      is_check: false,

      ////////////////////////////////////////////////////////////////////
    };
  },
  activated() {
    this.loginModel.username = "";
    this.loginModel.password = "";
    this.loginModel.areaCode = BASE_AREA_CODE;
    this.getOnlinePath()
  },
  methods: {
    ...mapActions(["getUserInfo", "applyMemberLanguagePreference"]),
    ...mapMutations({ setToken: "SETTOKEN", setHanders: "SETHANDERS" }),
    loginEvent() {
      if (this.itemname == 'Hive') {
        this.onVCodeSuccess()
      } else {
        this.showVcoe = true;
      }
    },
    openService() {
      if (this.onlinePath) {
        window.open(
          this.onlinePath,
          "_blank"
        );
      } else {
        this.showOnlieService = true;
      }
    },
    async getOnlinePath() {
      // let res = await apiGetCustomerService({ code: 'customer_service_url' });
      // this.onlinePath = res.data.customer_service_url
    },
    onVCodeSuccess() {
      this.showVcoe = false;
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const loginResult = await loginApi({
              username: this.loginModel.username,
              password: encodeURIComponent(this.loginModel.password),
              areaCode: this.loginModel.areaCode,
              ...{
                username:
                  this.loginModel.areaCode + " " + this.loginModel.username,
              },
            });
            this.setToken(loginResult.data.token);
            await this.getUserInfo(loginResult.data);
            this.$message({
              message: this.$t(
                "message.home.loginSuccess" /**添加到购物车成功 */
              ),
              type: "success",
            });
            this.$refs.loginForm.resetFields();
            if (sessionStorage.getItem("path") == "/register") {
              this.$router.push("/");
              sessionStorage.setItem("path", "1");
            } else {
              this.$router.go(-1);
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
    goRegister() {
      this.$router.push("/register");
    },


    /////////////////////////////////////////////////////////////////////

    sendSms: function () {
      let that = this;
      var telnum = that.formData.mobile;
      if (telnum === '') {
        // uni.showModal({
        // 	title: this.messages['User_mobileNumber'] + ' ' + this.messages['notNull'],
        // });
        this.$message({
          message: '手机号不能为空',
          type: "success",
        });
        return;
      }

      that.countdown();
      sendCode({
        mobile: this.formData.mobile,
        type: '1'
      }).then(response => {
        this.msgKey = false
        if (response.status == '200') {
          // uni.showToast({
          // 	title: this.messages['common_smsCaptchaSent'],
          // 	duration: 2000,
          // 	icon: "none"
          // });
        }
      });

    },
    countdown: function () {
      let that = this;
      var second = that.second;
      if (second == 0) {
        that.getSmsShow = true;
        that.second = 60;
        return;
      }
      var time = setTimeout(function () {
        that.getSmsShow = false;
        that.second = second - 1;
        that.countdown();
      }, 1000)
    },
    onSMSLoginUser: function () {
      var that = this;
      if (this.formData.mobile === '') {
        this.$message({
          message: '手机号不能为空',
          type: "success",
        });
        // uni.showModal({
        // 	title: this.messages['User_mobileNumber'] + ' ' + this.messages['common_notNull'],
        // });
        return;
      }
      if (this.formData.code === '') {
        this.$message({
          message: '验证码不能为空',
          type: "success",
        });
        // uni.showModal({
        // 	title: this.messages['common_captcha_name'] + ' ' + this.messages['common_notNull'],
        // });
        return;
      }
      // if (!this.is_check) {
      // uni.showToast({
      // 	title: this.messages['common_UserServiceAgreement'],
      // 	duration: 3000,
      // 	icon: "none"
      // });
      // return;
      // }
      let spreadUserId=localStorage.getItem("spreadUserId");
      // if(spreadUserId){
      //   this.formData.obj['spreadUserId']=spreadUserId;
      // }	
      loginByPhone(this.formData.mobile, this.formData.code, spreadUserId).then(async response => {

        if (response.data.user) {
          this.$store.commit("SETUSERINFO", response.data.user);
          let handerData = {
            'authorization': 'Bearer ' + response.data.access_token,
            'userId': response.data.user.id,
            'username': response.data.user.username
          }
          this.setHanders(handerData)
          this.setToken(response.data.access_token);
          localStorage.setItem(BIZ_TOKEN, response.data.access_token);
          this.$message({
            message: this.$t(
              "message.home.loginSuccess" /**登录成功 */
            ),
            type: "success",
          });
          this.$refs.loginForm.resetFields();
          const langChanged = await this.applyMemberLanguagePreference();
          if (!langChanged) {
            navigateAfterLogin(this);
          }

        } else {

          // this.refreshCode();
          // uni.showToast({
          // 	title: this.messages[response.data.message],
          // 	duration: 5000,
          // 	icon: 'none'
          // })
        }

      });
    },
    checkedradio: function (value) {
      this.is_check = !value;
    }

    /////////////////////////////////////////////////////////////////////


  },
};
</script>
<style lang="scss" scoped>
html[dir="rtl"] {
  .el-form-item v::deep .el-form-item__error {
    right: 0;
    left: auto;
  }

  .login-content-form .form-phone .vue-country-popover-container {
    left: 12px;
  }

  .login-content-form .form-phone .area-code span {
    width: auto;
    padding-left: 0;
  }

  .login-content-form .form-phone .area-code {
    width: auto;
  }

  .el-input__inner {
    padding-left: 30px;
    padding-right: 0;
  }

  .vue-country-item.selected .selected-text {
    display: none;
  }
}

.vue-country-item.selected .selected-text {
  display: none;
}

v::deep .range-text {
  padding-left: 40px;
}

v::deep .el-input__inner{
  padding-left: 15px;
}
</style>